import { render, staticRenderFns } from "./ButtonLike.vue?vue&type=template&id=2b1dbba0&scoped=true"
import script from "./ButtonLike.vue?vue&type=script&lang=js"
export * from "./ButtonLike.vue?vue&type=script&lang=js"
import style0 from "./ButtonLike.vue?vue&type=style&index=0&id=2b1dbba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1dbba0",
  null
  
)

export default component.exports